import { VITE_BASE_URL } from "@/env";
import axios from "axios";
import { getIdentificationData } from "./identification.utils";

const { token } = getIdentificationData();

const buildRedirectUrl = () => {
  if (location.origin.includes("dpxpre")) {
    return "/carros-motor-pre-api/api";
  }
  return "/carros-motor-api/api";
};

export const BASE_URL_API = `https://dpx.iberia.es${location.origin.includes("dpx") ? buildRedirectUrl() : "/api"}`;

const api = axios.create({
  baseURL: `${BASE_URL_API}/v1`,
  headers: {
    "Content-Type": "application/json",
    Authorization: token,
  },
});

export default api;
